import {useEffect} from 'react'

import {Hash} from '../types'
import useReachGoalCallback from './useReachGoalCallback'

export default function useReachGoalEffect<TParams extends object = Hash<string>>(goal: string, params?: TParams) {
  const reachGoal = useReachGoalCallback<TParams>()
  useEffect(() => {
    reachGoal(goal, params)
  }, [goal, params, reachGoal])
}
